import React from 'react';
import ReactTooltip from 'react-tooltip';
import './TruncatedCell.scss'

interface ITruncatedCellProps {
    value?: string;
}

type TruncatedCellState = {
    isTruncated: boolean;
};

export default class TruncatedCell extends React.Component<ITruncatedCellProps, TruncatedCellState> {
    private spanRef: React.RefObject<HTMLSpanElement>;
    private resizeObserver?: ResizeObserver;
    private debounceTimeout?: ReturnType<typeof setTimeout>;

    constructor(props: ITruncatedCellProps) {
        super(props);
        this.state = { isTruncated: false };
        this.spanRef = React.createRef();
    }

    componentDidMount() {
        this.observeResize();
        this.checkTruncation();
    }

    componentWillUnmount() {
        this.resizeObserver?.disconnect();
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
    }

    observeResize() {
        if (this.spanRef.current) {
            this.resizeObserver = new ResizeObserver(() => this.debounceCheckTruncation());
            this.resizeObserver.observe(this.spanRef.current);
        }
    }

    debounceCheckTruncation() {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => this.checkTruncation(), 50);
    }

    checkTruncation() {
        const element = this.spanRef.current;
        if (element) {
            const isTruncated = element.scrollWidth > element.clientWidth;
            if (isTruncated !== this.state.isTruncated) {
                this.setState({ isTruncated });
            }
        }
    }

    render() {
        const { value } = this.props;
        const { isTruncated } = this.state;

        return (
            <>
                <span
                    ref={this.spanRef}
                    data-tip={isTruncated ? value : ''}
                    className="truncate"
                >
                    {value}
                </span>
                <ReactTooltip multiline={true} />
            </>
        );
    }
}
